import axios from "axios";
import endpoints from "endpoints";
import { useQuery } from "react-query";

import { IPrpSessionFeedback } from "../prpSessionFeedback.type";

const getPrpSessionFeedback = async () => axios.get(endpoints.getPrpSessionFeedbackList);
export const useFeedbackList = () =>
    useQuery([endpoints.getOffersList], async () => {
        const { data } = await getPrpSessionFeedback();
        return data as IPrpSessionFeedback;
    });
